module.exports = __webpack_public_path__ + "static/testimonials-2-e15891260abfd3ae5a59017adc6e7ce1.png";